import $ from 'jquery'
import {Core} from './core'
import {Slider} from "./slider.js";

export class Tabs {
  constructor() {
    this.$window = $(window)
    this.data = {
      active: 'active',
      tab: 'tab',
      tabLink: 'tab-link',
      tabContent: 'tab-content',
      tabDisableHash: 'tab-disable-hash',
      tabCanActiveMultiple: 'tab-can-active-multiple',
      tabCanDisableAll: 'tab-can-disable-all',
      tabCanDisableAllMobile: 'tab-can-disable-all-mobile',
      tabCanDisableAllDesktop: 'tab-can-disable-all-desktop',
      scrollOnActiveTabDesktop: 'tab-scroll-on-active-tab-desktop',
      onlyDesktop: 'only-desktop',
      onlyMobile: 'only-mobile',
      bpMobile: 'bp-mobile',
      tabHiddenItem: 'tab-hidden-item',
      tabShowAll: 'tab-show-all'
    }
    this.containerData = 'tab'
    this.containerSelector = `[data-${this.containerData}]`
    this.isScriptWhoChangeUrl = false

    if ($(this.containerSelector).length === 0) {
      return
    }

    $(this.containerSelector).on('click', `[data-${this.data.tabLink}]`, this.handleClickLinkTab.bind(this))
    $(`[data-${this.data.tabShowAll}]`).on('click', this.handleClickShowAll.bind(this))
    $(document).ready(this.handleLoadHashScroll.bind(this))
    this.$window.on('hashchange', this.handleLoadHashScroll.bind(this))
  }

  handleClickLinkTab(e) {
    let $tabLink = $(e.currentTarget)
    let $container = $tabLink.closest(this.containerSelector)
    let bp = $container.data(this.data.bpMobile) || 'md'

    if ($container.data(this.data.onlyMobile) !== undefined && Core.isBpGreaterThan(bp)) {
      return
    }

    if ($container.data(this.data.onlyDesktop) !== undefined && Core.isBpLessThan(bp)) {
      return
    }

    e.preventDefault()
    e.stopImmediatePropagation()

    let tabDisableHash = $container.data(this.data.tabDisableHash)

    if ($tabLink.hasClass(this.data.active)) {
      if ($container.find(`[data-${this.data.tabLink}].${this.data.active}`).length > 1) {
        this.deactivateTab($tabLink)

        if (tabDisableHash) {
          this.removeHashUrl($tabLink)
        }
      }

      if ($container.data(`${this.data.tabCanDisableAll}`) !== undefined) {
        this.deactivateTab($tabLink)

        if (tabDisableHash) {
          this.removeHashUrl($tabLink)
        }
      }

      if (Core.isBpLessThan(bp) && $container.data(`${this.data.tabCanDisableAllMobile}`) !== undefined) {
        this.deactivateTab($tabLink)

        if (tabDisableHash) {
          this.removeHashUrl($tabLink)
        }
      }

      if (Core.isBpGreaterThan(bp) && $container.data(`${this.data.tabCanDisableAllDesktop}`) !== undefined) {
        this.deactivateTab($tabLink)

        if (tabDisableHash) {
          this.removeHashUrl($tabLink)
        }
      }

      return
    }

    if ($container.data(`${this.data.tabCanActiveMultiple}`) === undefined) {
      this.deactivateTabs($tabLink)
    }

    this.activateTab($tabLink)

    if (tabDisableHash) {
      this.changeHashUrl($tabLink)
    }
  }

  handleClickShowAll(e) {
    e.preventDefault()

    this.showAllItems($(e.currentTarget).closest('section'))
  }

  showAllItems($section) {
    $section.find(`[data-${this.data.tabHiddenItem}]`).removeAttr('hidden')
    $section.find(`[data-${this.data.tabShowAll}]`).parent().remove()
  }

  handleLoadHashScroll(e) {
    if (this.isScriptWhoChangeUrl) {
      this.isScriptWhoChangeUrl = false
      return
    }

    if (window.location.hash != '' && window.location.hash.length) {
      let $tabLink = $(`[data-${this.data.tabLink}="${window.location.hash.substring(1)}"]`)

      if ($tabLink.length) {
        if ($tabLink.closest(`[data-${this.data.tabHiddenItem}]`).length) {
          this.showAllItems($tabLink.closest('section'))
        }

        this.deactivateTabs($tabLink)
        this.activateTab($tabLink)

        setTimeout(() => Core.scrollTo($tabLink.closest(`[data-${this.containerData}]`), false), 600)
      }
    }
  }

  activateTab($tabLink) {
    let hashLink = $tabLink.data(`${this.data.tabLink}`)
    let $tabParent = $tabLink.closest(this.containerSelector)
    let $tabContent = $tabParent.find(`[data-${this.data.tabContent}="${hashLink}"]`)

    $tabContent.addClass(this.data.active)
    $tabLink.addClass(this.data.active)

    $tabLink.parent().parent().animate({
      scrollLeft: `+=${$tabLink.offset().left - $tabLink.parent().parent().offset().left}px`
    }, 150);

    if ((Core.isBpGreaterThan('md') && $tabParent.data(this.data.scrollOnActiveTabDesktop) !== undefined) || Core.isBpLessThan('md') ) {
      setTimeout(() => {
        Core.scrollTo($tabContent, false)
      }, 300)
    }

    if ($tabContent.find('[data-slider]')) {
      const sliderController = new Slider()

      $tabContent.find('[data-slider]').each((index, slider) => {
        if (slider.classList.contains('slick-initialized')) {
          $(slider).slick('unslick')
        }
        sliderController.generateSlider(index, slider)
      })
    }
  }

  deactivateTabs($tabLink) {
    let $container = $tabLink.closest(this.containerSelector)

    $container.find(`.${this.data.active}`).removeClass(this.data.active)
    $('header').focus()
  }

  deactivateTab($tabLink) {
    let hashLink = $tabLink.data(`${this.data.tabLink}`)
    let $tabContent = $tabLink.closest(this.containerSelector).find(`[data-${this.data.tabContent}="${hashLink}"]`)

    $tabContent.removeClass(this.data.active)
    $tabLink.removeClass(this.data.active)

    $('header').focus()
  }

  changeHashUrl($tabLink) {
    let hashLink = $tabLink.data(`${this.data.tabLink}`)
    let newHash = `#${hashLink}`

    if (window.location.hash !== newHash) {
      this.isScriptWhoChangeUrl = true
    }
    window.location.hash = newHash
  }

  removeHashUrl() {
    this.isScriptWhoChangeUrl = true
    history.pushState("", document.title, window.location.pathname + window.location.search)
  }
}
